module.exports = {
  "Gattaran_MSGCenter__CDEL": "消息接入说明",
  "Gattaran_Feedback__gRVu": "最多只能上传1个非图片类型的附件",
  "Gattaran_V2_wZWG_RFvr": "上传发送人群",
  "Gattaran_Homepage__SgjR": "权限列表",
  "Gattaran_Homepage__nRqe": "暂无访问记录",
  "Gattaran_Feedback__vYiO": "请选择",
  "common_yes": "是",
  "Gattaran_MSGCenter__fKLA": "请选择",
  "Gattaran_Feedback__bpPs": "问题描述",
  "Gattaran_Feedback__QLll": "问题发生的Gattaran功能模块",
  "Gattaran_V2_FXzs_ylzm": "提交审核",
  "Gattaran_V2_aQes_enLD": "说明",
  "Gattaran_MSGCenter__JYjL": "请输入",
  "Gattaran_Feedback__TtBS": "问题发生的页面链接",
  "Gattaran_Feedback__zEDP": "图片附件（最多5张，每张不超过5M）",
  "Gattaran_Feedback__AOcA": "提交人",
  "Gattaran_MSGCenter__rsFg": "删除",
  "Gattaran_MSGCenter__jECw": "业务接入发送",
  "Gattaran_Feedback__auMY": "查看",
  "Gattaran_MSGCenter__mzAm": "消息中心",
  "Gattaran_MSGCenter__esKt": "请输入消息标题关键词",
  "Gattaran_system_KMzx_LdcE": "反馈已提交至lean后台进行处理，您可以通过该链接了解问题处理进展",
  "Gattaran_Homepage__Ntsj": "请联系接口人处理：{{pm_name}}",
  "Gattaran_MSGCenter__YFIH": "ID",
  "Gattaran_Feedback__zikb": "您可以通过【我的反馈】列表了解问题反馈的处理进展",
  "FoodB_up250108_UBUH_aRBX": "请设置弹窗时间",
  "Gattaran_Homepage__qJVu": "我的申请、我的角色、我的审核的入口移动到这里了",
  "Gattaran_V2_tuhT_AOTp": "周期发送",
  "Gattaran_V2_qdkl_zhnr": "上限",
  "Gattaran_V2_elkQ_uPKA": "次",
  "Gattaran_20240401_cZwR_udOc": "调研详情",
  "Gattaran_V2_DECM_uvLB": "链接按钮名称（默认展示为“{{default}}”）",
  "sailing.dilu.myfeedback": "我的反馈",
  "Gattaran_V2_crhT_oxkz": "审核中",
  "Gattaran_Feedback_aLLw_KcWa": "技术咨询",
  "Gattaran_Feedback__EAYk": "ID",
  "Gattaran_Homepage__IEfB": "最近访问陈列的是你近期访问过的功能，是一个快捷访问入口",
  "soda-b-web-i18n---加载中": "加载中",
  "Gattaran_Homepage__HleZ": "以下角色具备该页面权限：",
  "Gattaran_Feedback__MQam": "紧急程度",
  "Gattaran_MSGCenter__GFMl": "目标人数",
  "Gattaran_Homepage__TQJz": "当前页面暂未接入新版Gattaran，如需访问请点击下方按钮",
  "Gattaran_Homepage__HCuT": "主导航",
  "Gattaran_MSGCenter__buje": "新建",
  "Gattaran_V2_uXMx_qica": "下载模板",
  "Gattaran_MSGCenter__Nbaz": "开始时间",
  "Gattaran_Feedback_PXop_Eszz": "运营协助",
  "Gattaran_MSGCenter__yaaT": "消息链接",
  "Gattaran_MSGCenter__SAQd": "生效周期",
  "Gattaran_Feedback__IdvX": "其它附件（excel、pdf、word，限1个）",
  "Gattaran_Feedback__RCjf": "创建新的问题反馈",
  "Gattaran_MSGCenter__jnGI": "内容设置",
  "Gattaran_Feedback_jzdw_zMgo": "我可能发现了一个技术bug",
  "Gattaran_Feedback__dglB": "问题描述",
  "Gattaran_Feedback_LxIv_wsSj": "我有个功能需求/建议",
  "Gattaran_Feedback__eNEw": "问题发生的区域",
  "Gattaran_Feedback__Xbej": "高",
  "FoodOpD_tools_Original_file_QXqs": "原文件下载",
  "Gattaran_Feedback_aSQV_CWCu": "你需要什么帮助？",
  "FoodD_one_Try_again_qZka": "重试",
  "Gattaran_MSGCenter__ZPZZ": "标题关键词",
  "Gattaran_20240401_BAMn_cVoR": "选择题请至少设置两个选项",
  "soda-t-i18n---确定": "确定",
  "Gattaran_Feedback_yoej_DTPb": "我需要技术团队的支持",
  "Gattaran_V2_OAkm_oSIp": "选项中的末级产品模块将作为消息发送者展示在Gattaran消息中心",
  "Gattaran_20240401_heKh_sVNg": "是否必填",
  "Gattaran_MSGCenter__HjTW": "消息中心后台发送",
  "Gattaran_MSGCenter__PvCm": "发送时间",
  "Gattaran_Feedback__fRJi": "中",
  "Gattaran_Feedback__dOJj": "低",
  "Gattaran_MSGCenter__MWqV": "查询",
  "Gattaran_MSGCenter__imft": "最多只能上传一张图片",
  "Gattaran_Feedback__JuAw": "处理结论提交成功，问题反馈状态变更为“已完成”",
  "Gattaran_Auth_dmRq_HvpZ": "无法使用？",
  "Gattaran_Homepage__Hjbo": "联系我们",
  "Gattaran_Feedback_FAZM_REhE": "我想知道这个功能怎么用",
  "取消": "取消",
  "Gattaran_MSGCenter__qJkV": "生效中",
  "Gattaran_20240401_Dqdw_zVjj": "是否确认发布？",
  "Gattaran_V2_wQRP_UYwo": "审核人",
  "Gattaran_MSGCenter__iuwu": "请输入ID",
  "Gattaran_20240401_ycgC_XryN": "调研中心",
  "Gattaran_Feedback__EhcV": "反馈信息",
  "FoodOpC_gattaran_Enter_CWSB": "请输入",
  "Gattaran_20240401_SptO_OiTm": "字数已超出限制",
  "Gattaran_20240401_dWRX_PBUn": "调研类型",
  "Gattaran_MSGCenter__kLtS": "结束时间",
  "Gattaran_Homepage__ybCE": "在首页，你可以查看Gattaran系统全貌",
  "Gattaran_Feedback_oHQm_chDu": "请进下面这个DChat群反馈问题细节，以便运营团队为您提供支持",
  "Gattaran_Feedback__lQre": "提交人",
  "Gattaran_MSGCenter__AjjW": "定时发送",
  "Gattaran_V2_ayrB_ekxC": "封面图片（宽高比3:1，建议宽度大于800px）",
  "Gattaran_MSGCenter__vrnW": "查看详情",
  "Gattaran_Homepage__YscW": "更多",
  "Gattaran_Homepage__ssGO": "缺少权限：{{node_info}}",
  "Gattaran_Feedback__HTsy": "提交",
  "Gattaran_Feedback__urHD": "低",
  "Gattaran_MSGCenter__KgwQ": "发布",
  "Gattaran_MSGCenter__UnwR": "新建",
  "Gattaran_Homepage__DMWj": "研发接入手册",
  "Gattaran_Feedback__cLbb": "中",
  "Gattaran_Feedback_NvwL_Uxho": "我需要其它运营类支持",
  "Gattaran_V2_Tzot_kaOW": "消息中心使用手册（面向产研产运）",
  "Gattaran_MSGCenter__pUdp": "消息详情",
  "Gattaran_V2_jXfh_Bzau": "请先设置“时区选择”",
  "Gattaran_Feedback_baMd_rUqS": "菜单变更请求",
  "Gattaran_DataPortal__aqBh": "STAR(数据门户)",
  "Gattaran_20240401_bAxu_VxZT": "完成人数",
  "DiDi_Food_(C)_Customer_automatically_apply_Add_ZyML": "添加",
  "Gattaran_MSGCenter__jcAm": "请选择",
  "Gattaran_Feedback_UUdB_fdYt": "我有一个待审核任务",
  "Gattaran_Feedback__qGnl": "反馈已提交给产品接口人{{pm_name}}",
  "Gattaran_20240401_cSnz_WMLD": "多选题",
  "Gattaran_20240401_iuEu_VEPo": "评分题（十级）",
  "Gattaran_alert_zVGm_gOUV": "发现新版本数据，刷新后可获取最新内容",
  "Gattaran_0411_MWuz_zfQj": "投放位置",
  "Gattaran_MSGCenter__wEBm": "暂无消息",
  "Gattaran_Homepage__XHuN": "Gattaran系统基础配置功能集合，包括任务、审核、消息配置、问题反馈等",
  "Gattaran_Homepage__ktsW": "确认",
  "Gattaran_Feedback__OHxt": "问题反馈",
  "Gattaran_Homepage__vkPG": "点击群链接加入",
  "Gattaran_Homepage__yTjZ": "你暂无该页面的访问权限",
  "Gattaran_MSGCenter__tcGJ": "发送方式",
  "Gattaran_MSGCenter__tOPK": "用途描述",
  "Gattaran_MSGCenter__mwuC": "消息标题",
  "Gattaran_MSGCenter__jtwt": "创建时间",
  "FoodOpB_Gattaran_Edit_dTpu": "编辑",
  "Gattaran_V2_uLPb_Hgku": "自定义人群",
  "Gattaran_V2_pLhS_NyGm": "消息后台配置发送",
  "Gattaran_20240401_Dror_RtHt": "题目类型",
  "soda-t-i18n---取消": "取消",
  "Gattaran_Feedback__LtzD": "问题反馈",
  "Gattaran_20240401_mhox_xExM": "请输入题目描述",
  "Gattaran_20240401_gZfx_mUCE": "该问卷一经发布，将在BD APP上强制弹窗展示并不可关闭，是否确认发布？",
  "Gattaran_lowcode_dTZL_JDSp": "已打开新窗口，请在浏览器中查看",
  "Gattaran_Feedback__KBWX": "状态更新时间",
  "soda-d-i18n---下载": "下载",
  "Gattaran_Feedback__HgXn": "开始处理",
  "Gattaran_Feedback__ZHEu": "问题分类",
  "Gattaran_Homepage__VxjE": "工具栏",
  "Gattaran_MSGCenter__NWqi": "查看",
  "Gattaran_20240401_EyCp_urep": "单选题",
  "Gattaran_Feedback__yvfR": "取消",
  "Gattaran_Feedback__amKQ": "高",
  "Gattaran_MSGCenter__xZzf": "生效周期",
  "Gattaran_Homepage__dzQv": "这个功能还没有关联角色权限",
  "Gattaran_20240401_BIfp_ZYiB": "评分题（五级）",
  "Gattaran_20240401_gSOw_DugT": "最近30天内已经设置{{research_num}}个通过BD APP首页提示的调研，数量过多可能会打扰BD的日常工作，是否确认发布？",
  "FoodB_up250108_fBFI_ZRnR": "弹窗限制时间（谨慎选择，设置后规定时间内不能关闭弹窗，最长为10s）",
  "Gattaran_lowcode_axmA_FvoV": "未获取到URL，请点击重试或联系平台管理员处理",
  "Gattaran_Homepage__YLig": "友情链接",
  "Gattaran_MSGCenter__PuUe": "正在加载中…",
  "Gattaran_Feedback__EqVZ": "紧急程度",
  "Gattaran_Homepage__upog": "欢迎访问Gattaran",
  "Gattaran_Homepage__kLUb": "个人中心",
  "Gattaran_MSGCenter__Kbqd": "请设置定时发送时间",
  "Gattaran_Feedback__dWQe": "处理人",
  "Gattaran_MSGCenter__GxXJ": "请设置",
  "Gattaran_MSGCenter__cEqf": "请输入",
  "Gattaran_MSGCenter__BZkt": "发送记录",
  "Gattaran_MSGCenter__VINe": "展开",
  "FoodB_system_AFma_LhIY": "需求类",
  "Gattaran_Homepage__GVcy": "设计资源下载",
  "Gattaran_Feedback__ddlX": "问题反馈",
  "Gattaran_Homepage__FxHz": "我知道了",
  "Gattaran_Homepage__QaKY": "时区：{{cityname}}",
  "FoodOpB_management_Maximum_quantity_JEJp": "已达到最大数量限制",
  "Gattaran_MSGCenter__rffG": "重置",
  "Gattaran_Homepage__XxTT": "接入指南",
  "Gattaran_Feedback__SwBm": "操作",
  "Gattaran_Homepage__anfP": "点击可查看功能模块对应的角色列表",
  "Gattaran_Feedback__chUi": "请输入问题的详细描述，比如When、How to do、What、How often等",
  "Gattaran_Feedback__cEaW": "所属模块",
  "Gattaran_Homepage__KEfd": "点击主导航上的选项，比如商家端、骑手端、数据产品，可以切换对应的子系统。在子系统内的左侧导航，会展示你当前所有有权限的子系统功能模块。每个子系统都提供功能概览页面，你可以查看子系统功能全集，获取相关角色列表，以及快捷发起权限申请",
  "FoodB_I_Exit_sfrY": "退出",
  "Gattaran_Homepage__AHIW": "产品设计手册",
  "Gattaran_Feedback__SHVh": "处理人",
  "Gattaran_Feedback_JvYQ_JyXO": "我希望变更店铺/主体信息",
  "Gattaran_V2_LuUu_Rpls": "审核不通过",
  "Gattaran_MSGCenter__myYJ": "下载模板",
  "sailing.dilu.SysBasicConfig": "系统配置",
  "Gattaran_MSGCenter__XIYn": "消息配置",
  "Gattaran_Feedback__Govn": "问题发生的区域",
  "Gattaran_V2_NzFp_yjYY": "查看详情",
  "Gattaran_MSGCenter__FtSp": "添加",
  "soda-m-i18n---您当前的网络环境不太好，请更换至网络稳定的环境再次尝试": "您当前的网络环境不太好，请更换至网络稳定的环境再次尝试",
  "Gattaran_Feedback__fnhs": "处理结论",
  "Gattaran_Homepage__OukI": "使用旧版",
  "Gattaran_Feedback__ykZG": "最多上传5张图片",
  "FoodB_system_MBBl_SUqv": "BUG类",
  "Gattaran_Homepage__SbiO": "产品已按照业务场景重新分类，来熟悉新的分类方式吧，还可以发现更多有帮助的功能",
  "Gattaran_MSGCenter__kiOa": "所属业务",
  "Gattaran_Feedback_BnWd_kcBd": "我发现一个文案错误",
  "Gattaran_Feedback_Uxer_NPzU": "我没有这个功能权限",
  "Gattaran_MSGCenter__esUP": "确定停止吗？",
  "FoodB_202502_iDjM_HZOr": "请勿重复提交",
  "Gattaran_0416_aBBV_Ymcw": "多行输入框",
  "Gattaran_V2_KeYD_zlnO": "发送时间需要 <= 消息卡片生效周期的开始时间",
  "Gattaran_Feedback__mVws": "上传",
  "FoodOpC_Notifications_Time_zone_YaBE": "时区",
  "Gattaran_MSGCenter__Xxgq": "取消",
  "FoodOpB_copy_The_interval_zsXr": "订单时间间隔不能超过{{day}}天",
  "Gattaran_Homepage__Tchu": "最近访问",
  "Gattaran_MSGCenter__pLZR": "每天",
  "Gattaran_Homepage__XQjL": "申请权限",
  "Gattaran_MSGCenter__xOWq": "消息内容",
  "Gattaran_V2_yYKm_eBiS": "弹出消息卡片",
  "Gattaran_V2_lotK_apqj": "最多",
  "Gattaran_MSGCenter__HxEk": "全部",
  "Gattaran_MSGCenter__ehbg": "时区选择",
  "Gattaran_V2_omYw_wLSK": "内容图片（最多上传4张）",
  "Gattaran_Homepage__PTEn": "下一步",
  "Gattaran_MSGCenter__eNOL": "请输入",
  "FoodC_remind_Unable_to_Wjlz": "加载失败，请点击重试",
  "Gattaran_MSGCenter__iWDe": "基础设置",
  "Gattaran_MSGCenter__DUmv": "立即发送",
  "Gattaran_Feedback__SPGu": "当前处理状态",
  "Gattaran_lowcode_dnHP_Gabp": "页面加载失败，请点击重试或联系平台管理员处理",
  "Gattaran_Homepage__lnWD": "上一步",
  "Gattaran_MSGCenter__yJJS": "产品模块",
  "Gattaran_MSGCenter__bLAo": "图片（建议尺寸624px*312px）",
  "Gattaran_Homepage__uCVu": "查看引导",
  "Gattaran_Homepage__lXkk": "设置国家、时区、语言",
  "Gattaran_MSGCenter__vKEM": "默认版本",
  "Gattaran_MSGCenter__oHtl": "全部已读",
  "Gattaran_MSGCenter__lbqY": "操作",
  "Gattaran_Homepage__bYLT": "首页",
  "FoodB_system_cYsu_ZWYN": "操作查询类",
  "Gattaran_MSGCenter__xBnV": "已发布",
  "Gattaran_Homepage_soPn_KBFC": "常用组件和页面模板",
  "Gattaran_MSGCenter__XgxF": "推送人群",
  "FoodOpB_Authority2_Role_List_OQWs": "角色列表",
  "Gattaran_Feedback__ktgU": "这不是一个合格的页面链接",
  "Gattaran_Feedback__zzVL": "问题发生的页面链接",
  "Gattaran_Feedback_tIFD_xuzA": "产品建议",
  "Gattaran_Feedback__adec": "已开始处理，问题反馈状态变更为“处理中”",
  "Gattaran_MSGCenter__wdfs": "已完成",
  "FoodB_system_EWCs_iStS": "工单类型",
  "Gattaran_Feedback__xywA": "请输入",
  "Gattaran_20240401_SucJ_yXvM": "问题选项",
  "Gattaran_Homepage__qMzz": "或使用D-Chat扫码加入“Gattaran线上问题反馈群”",
  "Gattaran_MSGCenter__ypXf": "发送时间",
  "Gattaran_MSGCenter__SGXp": "确定删除吗？",
  "Gattaran_MSGCenter__sQlj": "创建人",
  "Gattaran_MSGCenter__wYPN": "接收应用",
  "Gattaran_MSGCenter__CUTJ": "自定义{{version_num}}",
  "Gattaran_Feedback__pbpG": "反馈详情",
  "Gattaran_Feedback__BoaN": "问题分类",
  "Gattaran_V2_fiBJ_wAfB": "消息卡片生效周期",
  "Gattaran_MSGCenter__qflV": "请选择",
  "Gattaran_Homepage__MtRG": "查看权限",
  "sailing.dilu.newfeedback": "问题反馈",
  "Gattaran_0424_HooT_uHlF": "取消",
  "Gattaran_MSGCenter__sRnc": "请选择创建时间",
  "Gattaran_Homepage__aeIE": "点击跳转查看",
  "soda-m-i18n---查询到的数据有点小问题，请再试一次": "查询到的数据有点小问题，请再试一次",
  "Gattaran_Homepage__KisY": "如需使用该功能，请根据你的岗位情况申请适当的角色权限",
  "Gattaran_20240401_dTUg_cbfD": "调研内容配置",
  "Gattaran_20240401_EwyS_XNBx": "调研标题",
  "Gattaran_MSGCenter__WOKq": "收起",
  "Gattaran_Homepage__rxJe": "取消",
  "Gattaran_MSGCenter__fKVx": "消息标题",
  "Gattaran_MSGCenter__jVqk": "接收应用",
  "Gattaran_V2_HsHn_NQQR": "消息卡片展示频次",
  "Gattaran_V2_ghDi_LLbp": "发送人群",
  "Gattaran_Feedback__UgYW": "我知道了",
  "FoodB_statistics_Refresh_qDDP": "刷新",
  "Gattaran_MSGCenter__TIzW": "语言类型",
  "Gattaran_MSGCenter__Krud": "状态",
  "Gattaran_MSGCenter__gzaW": "请选择",
  "Gattaran_V2_kzRk_KWRP": "所有人群",
  "FoodB_2_Created_successfully_IqRa": "创建成功",
  "Gattaran_V2_Lyuv_BCOl": "该周期已被其它消息卡片占用",
  "Gattaran_MSGCenter__tgFp": "产品模块",
  "Gattaran_0424_aMnh_OeRE": "确定",
  "FoodC_sales_Not_set_AJmE": "暂不设置",
  "Gattaran_20240401_vCtD_sEvO": "新建调研问卷",
  "Gattaran_MSGCenter__chmB": "无更多消息",
  "Gattaran_Homepage__KYtj": "语言",
  "Gattaran_Homepage__lRUO": "国家",
  "Gattaran_0416_eOIG_voOz": "添加一个问题",
  "Gattaran_Homepage__AmGl": "已有权限",
  "Gattaran_V2_XkEi_RPoU": "每天{{num}}次",
  "Gattaran_Homepage__BYnh": "无权限",
  "Gattaran_Homepage__Fkve": "你可以在这里设置国家、语言，查看消息通知，反馈问题",
  "Gattaran_Feedback__QMDO": "处理进度",
  "Gattaran_Auth_fSHw_fDtt": "立即去申请权限",
  "Gattaran_Feedback__WUQR": "我的反馈",
  "Gattaran_Feedback__NySC": "反馈提交成功",
  "common_no": "否",
  "Gattaran_Feedback_hXFJ_wgsq": "商机管理请求（封禁/解封/创建/修改等）",
  "Gattaran_MSGCenter__jiXX": "消息类型",
  "Gattaran_Homepage__pnNi": "点击图标后访问首页。在首页，你可以快捷访问“最近访问”过的功能，也可以查看Gattaran系统全貌，以及快捷发起权限申请",
  "Gattaran_MSGCenter__SwjL": "停止",
  "Gattaran_Auth_BQfS_LpZc": "我要反馈问题",
  "Gattaran_MSGCenter__hpmD": "消息类型",
  "FoodOpB_entrance_Learning_Centre_ENzd": "学习中心",
  "FoodB_modification_Modified_sTAw": "修改成功",
  "FoodB_system_QnGW_PNFN": "文案类",
  "Gattaran_mgt_Tips_NpAN": "提示",
  "Gattaran_Homepage__oGEC": "概览",
  "Gattaran_Feedback__GGDd": "提交结论",
  "Gattaran_Feedback__EeVZ": "处理结论",
  "FoodB_up250108_muEZ_uUVF": "复制",
  "Gattaran_20240401_hhVY_xurV": "请设置题目",
  "Gattaran_Feedback__dGOG": "取消",
  "Gattaran_20240401_FchZ_ipbt": "基础信息配置",
  "Gattaran_MSGCenter__uZZb": "图片",
  "Gattaran_lowcode_xOev_XItQ": "未获取到页面资源，请点击重试或联系平台管理员处理",
  "Gattaran_MSGCenter__RtfX": "请输入描述，用于模板管理",
  "Gattaran_MSGCenter__oaHw": "已读人数",
  "Gattaran_0416_dvjl_GeNS": "问题{{num}}",
  "Gattaran_notice_dpsU_cOCk": "已删除",
  "Gattaran_MSGCenter__WGno": "请选择"
}